import { ScheduleType } from '@/app/(main)/(pages)/_components/schedules/_types/schedule-type.enum';
import { CartItem } from '@/types/cart.types';
import { NEAR_SCHEDULE_THRESHOLD_MINUTES } from '@/utils/schedule/is-schedule-near.util';

const MILLISECONDS_PER_MINUTE = 60 * 1000;

export function formatCartItemCountdownLabel(item: CartItem, now: Date = new Date()): string {
  const { scheduleType, start } = item.slot;

  if (scheduleType !== ScheduleType.SCHEDULED || !start) {
    return '';
  }

  const startTime = new Date(start).getTime();

  if (Number.isNaN(startTime)) {
    return '';
  }

  const remaining = startTime - now.getTime();

  if (remaining < 0 || remaining >= NEAR_SCHEDULE_THRESHOLD_MINUTES * MILLISECONDS_PER_MINUTE) {
    return '';
  }

  const minutes = Math.max(1, Math.floor(remaining / MILLISECONDS_PER_MINUTE));

  return `Atendimento em ${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}`;
}
